/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-28, 13:11:33
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-05, 12:23:25
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import { API, API_URL } from '@/config';
import { togglePendingStoreActions, handleErrorResponses } from '@/utils/decorators';

import {
  FILL_PAYMENTS_DATA, FILL_INVOICES_DATA, FILL_CORRECTION_INVOICES_DATA, SET_PAYMENTS_ERROR,
} from './mutation-types';

export default {
  @togglePendingStoreActions()
  @handleErrorResponses()
  async getCustomerPaymentsData({ commit }) {
    const { payments, correction_invoices } = (await API.get(`${API_URL}/payments`)).data.data;
    commit(FILL_PAYMENTS_DATA, { payments });
    commit(FILL_CORRECTION_INVOICES_DATA, { correction_invoices });
  },

  @togglePendingStoreActions()
  @handleErrorResponses()
  async getCustomerInvoicesData({ commit }) {
    const { list, count } = (await API.get(`${API_URL}/invoices`)).data.data;
    commit(FILL_INVOICES_DATA, { list, count });
  },

  @togglePendingStoreActions()
  @handleErrorResponses()
  async downloadInvoiceFile({ commit }, params = {}) {
    await API.post(`${API_URL}/invoice/checkIsExist`, { ...params });
    window.open(`${API_URL}/invoice/download?year=${params.year}&month=${params.month}`);
  },

  @togglePendingStoreActions()
  async genratePaymentToken({ commit }, params = {}) {
    try {
      const { url } = (await API.post(`${API_URL}/payments/token/generate`, { ...params })).data.data;
      commit(SET_PAYMENTS_ERROR, { paymentsError: null });
      window.location.href = url;
    } catch (err) {
      const errorData = (err.response && err.response.data) ? err.response.data.data : {};
      commit(SET_PAYMENTS_ERROR, {
        paymentsError: {
          message: errorData.message || 'Wystąpił nieoczekiwany błąd',
          dateFrom: errorData.date_from || null,
          dateTo: errorData.date_to || null,
        },
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/PaymentsAndInvoices/actions.js